import { Lightning } from '@lightningjs/sdk'

import { transparent } from '../../constants/colors'
import { LinkModelStylesEnum, TvCardTypesEnum } from '../../types/flo-enums'
import { TvGridContainerItem } from '../../types/flo-experience'
import { getItemSize, toCardRef, toContainerItem } from '../../utils/carouselUtils'
import TvCard from '../TvCards/TvBaseCard'
import TvEntityCard from '../TvCards/TvEntityCard'

const SPORTS_ROW_MARGIN_BOTTOM = 32
const GENERAL_ROW_MARGIN_BOTTOM = 80

export default class TvGridRow extends Lightning.Component {
  private _data: Array<TvGridContainerItem>
  private _currentTile: number
  private _totalEl: number
  private _rowId: number
  private _isCardFadeInEnabled: boolean = true

  static _template() {
    return {
      w: (w) => w,
      color: transparent,
      flex: { direction: 'row' },
      collision: true,
    }
  }

  set data(gridItems) {
    this._data = gridItems
    this._totalEl = gridItems.length

    this.patch({
      h: this.rowHeight + this.rowMarginBottom,
      children: gridItems.map((item, index) => {
        if (
          item.style !== LinkModelStylesEnum.Paginate &&
          item.style !== LinkModelStylesEnum.Open
        ) {
          const { h: itemHeight, w: itemWidth } = getItemSize(item.type, item.style)
          const containerItem = toContainerItem(
            item,
            index,
            this._rowId,
            itemHeight,
            itemWidth,
            item.style,
          )

          if (containerItem?.data?.type === TvCardTypesEnum.TvEntityCard) {
            ;(containerItem as unknown as TvEntityCard).isCardFadeInEnabled =
              this._isCardFadeInEnabled
          }

          return containerItem
        }
      }),
    })
  }

  set rowId(id) {
    this._rowId = id
  }

  get currentTile() {
    return this._currentTile
  }

  set currentTile(tile: number) {
    this._currentTile = tile
  }

  set isCardFadeInEnabled(isEnabled: boolean) {
    this._isCardFadeInEnabled = isEnabled
  }

  get totalEl() {
    return this._totalEl
  }

  get currentChild() {
    return this.childList.getByRef(toCardRef(this._currentTile)) as TvCard
  }

  get data() {
    return this._data
  }

  get rowHeight() {
    const itemType = this.data?.[0]?.type
    const itemSize = this.data?.[0]?.style
    return getItemSize(itemType, itemSize)?.h
  }

  get rowMarginBottom() {
    const cardType = this.data?.[0]?.type
    const marginBottom =
      cardType === TvCardTypesEnum.TvNavigationCard || cardType === TvCardTypesEnum.TvEntityCard
        ? SPORTS_ROW_MARGIN_BOTTOM
        : GENERAL_ROW_MARGIN_BOTTOM
    return marginBottom
  }

  _init() {
    this._currentTile = 0
  }

  _inactive() {
    this.patch({ children: null })
  }

  _getFocused() {
    return this.currentChild
  }

  _handleLeft() {
    if (this._currentTile > 0) {
      this._currentTile--
    } else {
      return false
    }
  }

  _handleRight() {
    if (this._currentTile < this._totalEl - 1) {
      this._currentTile++
    }
  }
}
